<script lang="ts">
	import Select from 'svelte-select';
	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();
	export let options = [];

	let selectedValue = undefined;
	const groupBy = (item: any) => item.generalInterest;
	function handleSelect(value: any) {
		let newVal = [];
		if (typeof value.detail !== 'undefined') {
			if (value.detail !== null) {
				value.detail.forEach((picked: any) => {
					if (picked.isGroupHeader) {
						JSON.parse(
							JSON.stringify(options).replace(/name/g, 'label').replace(/"id"/g, '"value"')
						).forEach((element: any) => {
							if (element.generalInterest === picked.value) {
								let ifIsGroup = element;
								ifIsGroup.isGroupItem = true;
								newVal.push(ifIsGroup);
							}
						});
					} else {
						newVal.push(picked);
					}
				});
				selectedValue = newVal;
				dispatch('message', newVal);
			}
		}
		selectedValue = newVal;
		dispatch('message', newVal);
	}
</script>

<div class="container">
	<div class="themed">
		<Select
			{selectedValue}
			items={JSON.parse(
				JSON.stringify(options).replace(/name/g, 'label').replace(/"id"/g, '"value"')
			)}
			isMulti={true}
			{groupBy}
			isGroupHeaderSelectable={true}
			on:select={handleSelect}
		/>
	</div>
</div>

<style>
	.themed {
		--background: #f5f5f5;
		--border: 1px solid rgba(0, 0, 0, 0.87);
		--multiItemBG: #66548f;
		--multiItemActiveBG: #776c8e;
		--multiItemActiveColor: white;
		--multiClearBG: white;
		--multiClearFill: #66548f;
		color: white;
		--itemColor: black;
		width: 70vw;
	}

	@media screen and (min-width: 940px) {
		.themed {
			width: 716px;
		}
	}
	.container {
		display: flex;
		flex-flow: wrap;
		padding: 0;
	}
</style>
